import React from "react"

export const InfoIcon = ({ size = 1, color = "#034055", warning = false }) => {
  return (
    <svg
      width={24 * size}
      height={24 * size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform: warning ? `rotate(180deg)` : undefined,
      }}
    >
      <g fill="none" fillRule="evenodd">
        <rect
          x="1.25"
          y="1.25"
          width="21.5"
          height="21.5"
          rx="10.75"
          stroke={color}
          strokeWidth="2.5"
        />
        <path
          d="M12.831 9.693c.068.384.176 3.195.324 8.433h-2.322l.324-8.433h1.674zm-.864-4.752c.204 0 .394.036.572.108a1.423 1.423 0 0 1 .778.756c.078.174.117.363.117.567 0 .198-.039.386-.117.563a1.454 1.454 0 0 1-1.35.877 1.473 1.473 0 0 1-1.044-.419 1.427 1.427 0 0 1-.423-1.021 1.417 1.417 0 0 1 .423-1.021c.132-.13.287-.23.463-.302.178-.072.371-.108.581-.108z"
          fill={color}
          fillRule="nonzero"
        />
      </g>
    </svg>
  )
}
